/**
 * @Developers
 *
 * To add new permission, use the existing constructor like its in getRoutingPermissions func.
 * To generate the _id, use mongo db id generation like the one from https://observablehq.com/@hugodf/mongodb-objectid-generator
 */

export const getAvailablePermissions = () => {
  return [
    {
      ref: "createClient",
      name: "Create Client",
      current: true,
      notes: "Create a new client",
      isNew: true,
    },
    {
      ref: "restrictDemoClientCreation",
      name: "Restrict Demo Client Creation",
      current: false,
      notes: "Restrict demo client creation",
      isNew: true,
    },
    {
      ref: "dataImport",
      name: "Data Import",
      current: true,
      notes: "Import data from a file",
      isNew: true,
    },
    {
      ref: "resetMasterData",
      name: "Reset Master Data",
      current: true,
      notes: "Reset master data",
    },
    {
      ref: "snapshotSave",
      name: "Save Scenario Snapshot",
      current: true,
      notes: "Save a snapshot of the current scenario",
    },
    {
      ref: "snapshotLoad",
      name: "Load Scenario Snapshot",
      current: true,
      notes: "Load a snapshot from saved scenarios",
    },
    {
      ref: "snapshotDelete",
      name: "Delete Scenario Snapshot",
      current: true,
      notes: "Delete a saved scenario snapshot",
    },
    {
      ref: "showDatabaseColumn",
      name: "Show Database Column",
      current: true,
      notes: "Show database column",
    },
  ];
};
